module.exports = __webpack_public_path__ + "img/success_icon.5565b694.png";